import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-electricity',
  templateUrl: './electricity.component.html',
  styleUrls: ['./electricity.component.scss']
})
export class ElectricityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
